// Module
var code = `<h1 class="p-h-16">Page introuvable</h1> `;
// Exports
module.exports = code;